/**
 * Created by Languagenut on 22/03/2019.
 */

import React  from 'react';
import {NavDropdown , Nav , Button , Card} from 'react-bootstrap'

export default class SectionMenu  extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state ={
            items:this.props.items || {},
            eventKey: this.props.selected
        }
    }

    componentWillReceiveProps(props) {

        this.props = props;
        console.log(props.items )
        this.setState({items:props.items || []})

    }

    onSelect(key){

        if(this.props.onSelect) this.props.onSelect(key)
    }

    render(){

        //if(!this.state.gotTranslations) return null;
        const handleSelect = eventKey => this.setState({eventKey:eventKey});
        let header = null;

        if(this.props.hasHeader)
        {
            header =  <Card.Header className>   {this.props.title}</Card.Header>;
        }

        let items = [];

        for(var idx = 0 ; idx < this.state.items.length; idx++)
        {
            if(this.state.items[idx].isSplitter)
            {
                items.push(<NavDropdown.Divider />);
                continue;
            }
            if (this.state.items[idx].disabled) {
                continue;
            }
            if (this.state.eventKey == this.state.items[idx].id) {
                items.push(<Nav.Link onClick={this.onSelect.bind(this , this.state.items[idx].id)} disabled={this.state.items[idx].disabled} eventKey={this.state.items[idx].id}>
                    <span style={{color:"#11adcd", fontWeight:"700",borderBottom: "2px solid #11adcd"}}>{this.state.items[idx].name}</span>
                    </Nav.Link>)
            } else {
                items.push(<Nav.Link onClick={this.onSelect.bind(this , this.state.items[idx].id)} disabled={this.state.items[idx].disabled} eventKey={this.state.items[idx].id}>
                    <span style={{color:"#11adcd", fontWeight:"500"}}>{this.state.items[idx].name}</span>
                </Nav.Link>)
            }
        }

        return <Card >
            {header}

            <Nav defaultActiveKey="/home" className="flex-column" onSelect={handleSelect}>
                {items}

        </Nav> </Card>

    }
}
